import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { Analytics } from '../analytics.service';

@Injectable({
  providedIn: 'root'
})
export class ConsoleAnalyticsService implements Analytics {
  onlyInDevMode = filter(() => !environment.production);

  constructor(private angulartics2: Angulartics2) {
    this.angulartics2.setUsername.pipe(this.onlyInDevMode).subscribe(this.logAction('setUsername'));
    this.angulartics2.setUserProperties.pipe(this.onlyInDevMode).subscribe(this.logAction('setUserProperties'));
    this.angulartics2.setUserPropertiesOnce.pipe(this.onlyInDevMode).subscribe(this.logAction('setUserPropertiesOnce'));
  }

  startTracking() {
    this.angulartics2.pageTrack.pipe(this.onlyInDevMode).subscribe(this.logAction('pageTrack'));
    this.angulartics2.eventTrack.pipe(this.onlyInDevMode).subscribe(this.logAction('eventTrack'));
  }

  private logAction(action: string) {
    return (x: any) => console.log(`ConsoleAnalytics(${action})`, x);
  }
}
